'use strict';

import Factory from 'generic.factory';

let factoryInstance = new Factory({
    className: 'js-datepicker',
    ensure: (resolve, callAfter) => {
        let instance = require('./js/generic.datepicker');
        resolve(callAfter(instance.default || instance));
    }
});

factoryInstance.init();

if(document.querySelector('.js-form-trigger')) {
    document.querySelector('.js-form-trigger').addEventListener("click", () => {
        factoryInstance = new Factory({
            className: 'js-datepicker',
            ensure: (resolve, callAfter) => {
                let instance = require('./js/generic.datepicker');
                resolve(callAfter(instance.default || instance));
            }
        });
        factoryInstance.init();
    });
}

export default factoryInstance;



// WEBPACK FOOTER //
// ./app/components/datepicker/main.js